import { Config } from '../constants/config.constant';
export const handleLengthMenu = (item) => {
	if (item.length > Config.lengthLabel) {
		return item.slice(0, Config.lengthLabel) + '...';
	}

	return item;
};
